import { render, staticRenderFns } from "./EnBlanco.vue?vue&type=template&id=0b01972c&"
import script from "./EnBlanco.vue?vue&type=script&lang=js&"
export * from "./EnBlanco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports